import { useBasket } from "../../providers"

import Layout from "./Layout"

export default function Cart(props) {
  const { basket } = useBasket()

  const hasAnyTotal = props?.hasAnyTotal || basket.length

  return hasAnyTotal ? <Layout {...props} /> : <></>
}
